const URIs = {
  //**login */
  login: "/login",
  get_user: "/api/user/login",
  agree_privacy_policy:"/api/user/agreePrivacyPolicy",
  //**pdf upload */
  pdf_upload: "/api/pt/pdf",

  //** pdf-img */
  get_pdf_img: "/api/pt/pdf-img",

  //** PT */
  get_pt_pdf: `/api/pt/pdf`,
  post_pt_video: "/api/pt/video",
  post_pt_slide_event: "/api/pt/slide-event",

  //page
  go_calibration:"/calibration",

  //company
  company:"/api/company",

  //** File */
  get_file: (id: number) => `/api/file/${id}`,

  //** PT COUNT */
  post_user_pt_count: `/api/user/ptCount`,
  //** NOW - PT COUNT & SATATUS */
  get_user_now: `/api/user/now`,

  //** update user status type */
  post_user_status_type: `/api/user/userStatusType`,
};

export default URIs;
